<div class="block white-bg rounded-large border">
  @let passenger = passengerWithDetails$ | async;

  @if (passenger) {
    <div class="flex flex--middle ps-large-x ps-medium-y border-bottom" data-hj-suppress>
      <fcom-icon
        [name]="passenger.accompanyingTravelerId ? SvgLibraryIcon.ADULT_INFANT : SvgLibraryIcon.SINGLE_PAX"
        class="ms-small-r"
      ></fcom-icon>
      <h3 class="nordic-blue-900-text font-heading-5">{{ passenger.firstName }} {{ passenger.lastName }}</h3>
    </div>

    <div class="ps-large-x ps-medium-y">
      <ul class="flex flex--column g-xsmall" data-testid="passenger-apis-details">
        @if (!passenger.started) {
          <li class="flex flex--middle g-xsmall error-900-text bold-type font-body-1">
            <fcom-icon class="flex--self-start flex--shrink0" [name]="SvgLibraryIcon.ALERT_TRIANGLE"></fcom-icon>
            <span data-testid="details-missing-title">{{
              'MMB.checkIn.steps.apis.infoBox.detailsMissing' | finLocalization
            }}</span>
          </li>
        } @else if (passenger.isInAgentReval || !passenger.completed) {
          <li class="flex flex--middle g-xsmall">
            <fcom-icon
              class="error-900-text flex--self-start flex--shrink0"
              [name]="SvgLibraryIcon.ALERT_TRIANGLE"
            ></fcom-icon>
            <div class="flex flex--column g-xsmall">
              <div data-testid="details-missing-or-incomplete-title" class="nordic-blue-900-text font-body-1 bold-type">
                {{ 'MMB.checkIn.steps.apis.infoBox.detailsMissingOrIncomplete' | finLocalization }}
              </div>
              <div data-testid="ensure-details-complete-title" class="nordic-blue-400-text font-body-2">
                {{ 'MMB.checkIn.steps.apis.infoBox.ensureDetailsComplete' | finLocalization }}
              </div>
            </div>
          </li>
        } @else if (passenger.completed) {
          <li class="flex flex--middle g-xsmall success-900-text bold-type font-body-1">
            <fcom-icon class="flex--self-start flex--shrink0" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
            <span data-testid="details-complete-title">{{
              'MMB.checkIn.steps.apis.infoBox.detailsComplete' | finLocalization
            }}</span>
          </li>

          @if (passenger.verifiersEnabled) {
            @if (passenger.swiped === true) {
              <li class="flex flex--middle g-xsmall success-900-text bold-type font-body-1">
                <fcom-icon class="flex--self-start flex--shrink0" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
                <span>{{ 'MMB.checkIn.steps.apis.infoBox.documentsPreChecked' | finLocalization }}</span>
              </li>
            } @else {
              <li class="flex flex--middle g-xsmall">
                <fcom-icon class="flex--self-start flex--shrink0" [name]="SvgLibraryIcon.EMPTY"></fcom-icon>
                <div class="flex flex--column g-xsmall">
                  <div class="nordic-blue-400-text font-body-2">
                    {{ 'MMB.checkIn.steps.apis.infoBox.seeAgentOrPreCheck' | finLocalization }}
                    <button class="inline-block underline bold-type font-body-2" (click)="openForm.emit()">
                      {{ 'MMB.checkIn.steps.apis.infoBox.seeAgentOrPreCheckButton' | finLocalization }}
                    </button>
                  </div>
                </div>
              </li>
            }
          }
        }
      </ul>

      <div class="align-right pr-small-t" *ngIf="hideEditButton === false">
        <fcom-button
          #buttonComponent
          [size]="ButtonSize.MEDIUM"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [text]="
            (!passenger.started
              ? 'MMB.labels.provideDetails'
              : passenger.completed
                ? 'MMB.labels.reviewOrUpdate'
                : 'MMB.labels.updateDetails'
            ) | finLocalization
          "
          (clickBtn)="openForm.emit({ passengerId: passenger.id, triggerElement: buttonComponent })"
        ></fcom-button>
      </div>
    </div>
  }
</div>
